module.exports = __webpack_public_path__ + "static/img/3137_phase_function_Paper_PointsHejduk_Prediction.ddb26c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3137_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MlXs
// module chunks = 0